import { useParams, Link } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { CATEGORIES } from "../../data/courses";
import { SectionTitle } from "../../components/ui/UI";
import CourseCard from "../../components/ui/CourseCard";
import styles from "./CategoryPage.module.css";
import CategoryIcon from "../../components/ui/CategoryIcon";

export default function CategoryPage() {
  const { id } = useParams();
  const { courses } = useApp();

  const category = CATEGORIES.find((c) => c.id === id);
  const filtered = id === "all" ? courses : courses.filter((c) => c.category === id);

  const isAll = id === "all";

  return (
    <div className={styles.page}>
      {/* Header */}
      <div className={styles.header}>
        <div className={`container ${styles.headerInner}`}>
          <div className={styles.breadcrumb}>
            <Link to="/">Home</Link>
            <span>›</span>
            <span>{isAll ? "All Courses" : category?.label}</span>
          </div>
          <div className={styles.headerContent}>
            <span className={styles.headerIcon}>
              {isAll ? "📚" : category?.icon}
            </span>
            <div>
              <h1 className={styles.headerTitle}>
                {isAll ? "All Courses" : category?.label}
              </h1>
              <p className={styles.headerSub}>
                {isAll
                  ? `Showing all ${courses.length} PDF courses`
                  : `${filtered.length} course${filtered.length !== 1 ? "s" : ""} · ${category?.description}`}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Category Pills */}
      <div className={styles.pills}>
        <div className="container">
          <div className={styles.pillRow}>
            <Link
              to="/category/all"
              className={[styles.pill, isAll ? styles.pillActive : ""].join(" ")}
            >
              All
            </Link>
            {CATEGORIES.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={[styles.pill, id === cat.id ? styles.pillActive : ""].join(" ")}
              >
                <CategoryIcon icon={cat.icon} size={18} /> {cat.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Courses Grid */}
      <div className={`container section-gap-sm`}>
        {filtered.length === 0 ? (
          <div className={styles.empty}>
            <span>🔍</span>
            <h3>No courses in this category yet</h3>
            <p>Check back soon — we're always adding new content.</p>
            <Link to="/category/all" className={styles.emptyLink}>Browse all courses →</Link>
          </div>
        ) : (
          <div className="grid-3">
            {filtered.map((course, i) => (
              <CourseCard key={course.id} course={course} delay={i * 70} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
